/* Cart drawer/page product rail — real ewa-product-card markup,
   server-rendered by sections/aycan-cart-recs-cards.liquid, not a JS
   look-alike. Re-inits when Dawn re-renders drawer HTML after cart updates. */
class AycanCartRecs extends HTMLElement {
  connectedCallback() {
    if (this._ran) return;
    this._ran = true;

    this.track = this.querySelector('[data-recs-track]');
    if (!this.track) return;

    this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    this.pid = this.getAttribute('data-product-id');
    this.mode = this.getAttribute('data-mode') || 'related';
    this.recommendationsUrl = this.getAttribute('data-recommendations-url');
    this.limit = parseInt(this.getAttribute('data-limit') || '6', 10);

    const load = this.mode === 'catalog' || !this.pid || !this.recommendationsUrl
      ? this.loadCatalog()
      : this.loadRecommendations().then((html) => (html ? html : this.loadCatalog()));

    load.then((html) => {
      if (!html) return;
      this.track.innerHTML = html;
      this.hidden = false;
    }).catch(() => {});
  }

  fetchCardsSection(url) {
    return fetch(url)
      .then((r) => (r.ok ? r.text() : null))
      .then((text) => {
        if (!text) return null;
        const doc = document.createElement('div');
        doc.innerHTML = text;
        const cards = doc.querySelector('[data-recs-cards]');
        return cards && cards.children.length ? cards.innerHTML : null;
      })
      .catch(() => null);
  }

  loadRecommendations() {
    const url = `${this.recommendationsUrl}?section_id=aycan-cart-recs-cards&product_id=${this.pid}&limit=${this.limit}`;
    return this.fetchCardsSection(url);
  }

  loadCatalog() {
    const url = `${this.root}?section_id=aycan-cart-recs-cards&limit=${this.limit}`;
    return this.fetchCardsSection(url);
  }
}

if (!customElements.get('aycan-cart-recs')) {
  customElements.define('aycan-cart-recs', AycanCartRecs);
}
